import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;

export class EventProvider {

    static init() {
        const initOfficeEvents = [
            Office.EventType.ItemChanged,
        ];

        for (let officeEvent of initOfficeEvents) {
            Office.context.mailbox.addHandlerAsync(officeEvent, (...args: any) => {
                EventBus.$emit(`Office.${officeEvent}`, ...args);
            });
        }
    }
}